import { DatePipe } from '@angular/common';
import { HttpClient, HttpHeaders, HttpResponse } from '@angular/common/http';
import { Component, Inject, OnInit } from '@angular/core';
import { FilterUtils } from 'primeng/components/utils/filterutils';
import { CommonSerivce } from '../shared/services/common.service';
import { UserService } from '../shared/services/user.service';


@Component({
    selector: 'entry',
  styleUrls: ['../shared/share.component.css'],
  providers: [CommonSerivce, UserService, DatePipe],
    templateUrl: './entry.component.html'
})
export class EntryComponent implements OnInit {

  public loggedInType: string = "";
  public numberOfExpiredDoc: number = 0;

  constructor(private http: HttpClient, @Inject('BASE_URL') originUrl: string
    , private bcp: CommonSerivce) {

    this.loggedInType = this.bcp.getCurrentUserAccountType();
    if (this.loggedInType=='E') {
      this.numberOfExpiredDoc = this.bcp.getCurrentNoOfExpiredDoc();
    }

  }

  ngOnInit() {

    //console.log("on init");

    FilterUtils['custom'] = (value, filter): boolean => {
      if (filter === undefined || filter === null || filter.trim() === '') {
        return true;
      }

      if (value === undefined || value === null) {
        return false;
      }

      return parseInt(filter) > value;
    };

  }


}
